'use strict';var _desc,_value,_class;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const ErrorMessages=require('../../../../../../../dist-es6/client/errorMessages');
const SocketResponse=require('../../../../../../../dist-es6/client/dtos/socketResponse');
const BaseControllerBackedDirective=require('../../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const HandleUncaughtErrors=require('../../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const BaseController=require('../../../../../../../dist-es6/client/angularCommon/baseController');let

StaffNumberSearchDirective=function(_BaseControllerBacked){_inherits(StaffNumberSearchDirective,_BaseControllerBacked);function StaffNumberSearchDirective(){_classCallCheck(this,StaffNumberSearchDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(StaffNumberSearchDirective,[{key:'templateUrl',get:function()
{return'/templates/features/emirates/emiratesDashboard/components/staffNumberSearchDirective/staffNumberSearchTemplate'}},{key:'objectBindings',get:function()

{return['selectedStaff','isMinimized']}},{key:'$inject',get:function()

{return['$scope','$timeout','$window','socketService','uncaughtErrorHandler']}},{key:'controller',get:function()

{return StaffNumberSearchController}}]);return StaffNumberSearchDirective}(BaseControllerBackedDirective);


const ControllerDefaults={
currentStaff:null,
results:[],
selectedStaff:[],
formatMap:new Map,
maxResults:15,
isMinimized:!1};


const _MinimumInputLenth=2;

const _ignoredEventMatchers=[

function(event){return _.get(event,'target.className','').includes('md-button')},


function(event){return _.get(event,'target.className','').includes('ripple')}];


const _keepChipsVisibleEventMatchers=[

function(event){return _.get(event,'path',[]).find(function(p){return _.get(p,'className','').includes('md-autocomplete-suggestions')})!==void 0},


function(event){return _.get(event,'path',[]).find(function(p){return _.get(p,'tagName')==='PULSAR-STAFF-NUMBER-SEARCH'})!==void 0}];


function _isMatchedEvent(event,matchers){
const originalEvent=_.get(event,'originalEvent');

if(!_.exists(originalEvent)){
return!1;
}

return matchers.some(function(matchFn){return matchFn(originalEvent)});
}let

StaffNumberSearchController=(_class=function(_BaseController){_inherits(StaffNumberSearchController,_BaseController);
function StaffNumberSearchController($scope,$timeout,$window,socketService,uncaughtErrorHandler){_classCallCheck(this,StaffNumberSearchController);var _this2=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler));

_this2._$scope=$scope;
_this2._$timeout=$timeout;
_this2._socketService=socketService;
_this2._$window=$window;

_.defaults(_this2,ControllerDefaults);



angular.element(_this2._$window).on('click',function(event){
if(_isMatchedEvent(event,_ignoredEventMatchers)){
return;
}

if(_isMatchedEvent(event,_keepChipsVisibleEventMatchers)){

event.preventDefault();
event.stopPropagation();

_this2._$timeout(function(){return _this2.showStaffChips=!0});
}else if(_this2.showStaffChips){


_this2._$timeout(function(){return _this2.showStaffChips=!1});
}
});return _this2;
}StaffNumberSearchController.prototype.

transformChip=function transformChip(chip){
if(angular.isObject(chip)){
return chip;
}

return{name:chip,type:'new'};
};StaffNumberSearchController.prototype.

_getFormattedStaff=function _getFormattedStaff(){
return this.selectedStaff.map(function(s){return`${s.staffNumber} ${s.mostRecentQualifiedRank?'('+s.mostRecentQualifiedRank+')':''}`}).join(', ');
};StaffNumberSearchController.prototype.


update=function(){var ref=_asyncToGenerator(function*(query){var _this3=this;
const results=yield this._update(query);

return yield new Promise(function(resolve){
_this3._$timeout(function(){return resolve(results)});
});
});function update(query){return ref.apply(this,arguments)}return update}();StaffNumberSearchController.prototype.

_update=function(){var ref=_asyncToGenerator(function*(query){
if(!query||query.length<_MinimumInputLenth){
return[];
}

const socketResponse=yield this._socketService.sendAndWaitForResponse('StaffNumberSearch',{query:query});

if(!SocketResponse.succeeded(socketResponse)){
this.isErrored=!0;
this._notificationService.displayNotification(ErrorMessages.OopsTryAgain,'error');
return[];
}

if(socketResponse.body.query!==query){
return[];
}

const currentlySelected=new Set(this.selectedStaff.map(function(s){return s.staffNumber}));

return socketResponse.body.results.filter(function(s){return!currentlySelected.has(s.staffNumber)});
});function _update(query){return ref.apply(this,arguments)}return _update}();StaffNumberSearchController.prototype.

selectStaffAndResetSearch=function selectStaffAndResetSearch(newSelectedStaff){var _this4=this;
if(!newSelectedStaff){

return;
}

this._$timeout(function(){
_this4.selectedStaff=_.uniq(_this4.selectedStaff.concat(newSelectedStaff),'staffNumber');
_this4.currentQuery='';
});
};return StaffNumberSearchController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'update',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'update'),_class.prototype)),_class);


module.exports=StaffNumberSearchDirective;
//# sourceMappingURL=staffNumberSearchDirective.js.map
